import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useLanguage } from '../../context/LanguageContext';
import { num } from './shopUtils';

export const CartButton = ({ testid }) => {
  const cart = useCart();
  const { language } = useLanguage();
  return (
    <button onClick={() => cart.setOpen(true)} className="relative ml-1 rounded-md p-2 text-gray-700 hover:bg-gray-100" aria-label={`Cart, ${cart.count} items`} data-testid={testid}>
      <ShoppingCart className="h-5 w-5" />
      {cart.count > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[#E31E24] px-1 text-[10px] font-bold text-white" data-testid={`${testid}-count`}>{num(cart.count, language)}</span>}
    </button>
  );
};
